import React from 'react'
import "./PageHeader.css";

function PageHeader(props) {
    return (
        <div className="pageTitleDiv">

        <h1 className="pageTitle">{props.title}</h1>
      </div>
    )
}

export default PageHeader
